/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarStacked100Vertical = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 20h20v2H2v-2zM16 2h6v6h-6V2zm0 7h6v9h-6V9zm2-5v2h2V4h-2zm0 7v5h2v-5h-2zM9 2h6v16H9V2zm2 2v12h2V4h-2zm-9 8h6v6H2v-6zM2 2h6v9H2V2zm2 12v2h2v-2H4zM4 4v5h2V4H4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartBarStacked100Vertical as ChartBarStacked100Vertical };
